<template>
  <!-- eslint-disable vue/no-v-html -->
  <p v-if="block.p" class="hb-p" v-html="fmt(block.p)"></p>

  <h4 v-else-if="block.h3" :id="anchorId" :data-spy="spyId" class="hb-h3">{{ block.h3 }}</h4>

  <ul v-else-if="block.list" class="hb-list">
    <li v-for="(t, i) in block.list" :key="i" v-html="fmt(t)"></li>
  </ul>

  <ol v-else-if="block.steps" class="hb-steps">
    <li v-for="(t, i) in block.steps" :key="i" v-html="fmt(t)"></li>
  </ol>

  <figure v-else-if="block.img" class="hb-fig">
    <button type="button" class="hb-fig__btn" :aria-label="'Perbesar gambar: ' + block.caption" @click="$emit('zoom', block)">
      <img :src="'/help/img/' + block.img" :alt="block.caption" loading="lazy">
    </button>
    <figcaption>{{ block.caption }}</figcaption>
  </figure>

  <div v-else-if="block.callout" class="hb-callout" :class="'hb-callout--' + block.callout">
    <strong class="hb-callout__label">{{ label[block.callout] }}</strong>
    <span v-html="fmt(block.text)"></span>
  </div>

  <div v-else-if="block.table" class="hb-table-wrap">
    <table class="hb-table">
      <thead>
        <tr><th v-for="(h, i) in block.table.head" :key="i">{{ h }}</th></tr>
      </thead>
      <tbody>
        <tr v-for="(r, i) in block.table.rows" :key="i">
          <td v-for="(c, j) in r" :key="j" v-html="fmt(c)"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { fmt, CALLOUT_LABEL } from '@/help/format'

export default {
  name: 'HelpBlock',
  props: {
    block: { type: Object, required: true },
    anchorId: { type: String, default: null },
    spyId: { type: String, default: null },
  },
  data: () => ({ label: CALLOUT_LABEL }),
  methods: { fmt },
}
</script>

<style scoped>
.hb-p { margin: 0 0 12px; line-height: 1.7; color: var(--esign-text); }
.hb-h3 {
  margin: 20px 0 8px;
  font-size: 15px;
  font-weight: 700;
  color: var(--esign-primary-strong, var(--esign-primary));
  scroll-margin-top: 88px;
}
.hb-list, .hb-steps { margin: 0 0 14px; padding-left: 22px; line-height: 1.7; color: var(--esign-text); }
.hb-list li, .hb-steps li { margin-bottom: 4px; }

.hb-fig { margin: 8px 0 18px; text-align: center; }
.hb-fig__btn {
  display: block;
  width: 100%;
  padding: 0;
  border: 1px solid var(--esign-border);
  border-radius: 8px;
  overflow: hidden;
  background: var(--esign-surface-muted);
  cursor: zoom-in;
}
.hb-fig__btn img { display: block; width: 100%; height: auto; }
.hb-fig figcaption { margin-top: 6px; font-size: 13px; color: var(--esign-primary-strong, var(--esign-primary)); }

.hb-callout {
  margin: 4px 0 16px;
  padding: 12px 16px;
  border-left: 4px solid var(--esign-primary);
  border-radius: 6px;
  background: var(--esign-primary-soft);
  line-height: 1.65;
  color: var(--esign-text);
}
.hb-callout__label { margin-right: 6px; }
.hb-callout--penting { border-left-color: var(--esign-error); background: var(--esign-error-bg); }
.hb-callout--tips { border-left-color: var(--esign-success); background: var(--esign-success-bg); }
.hb-callout--catatan { border-left-color: var(--esign-warning); background: var(--esign-warning-bg); }

.hb-table-wrap { margin: 4px 0 16px; overflow-x: auto; }
.hb-table { width: 100%; border-collapse: collapse; font-size: 14px; }
.hb-table th {
  padding: 8px 10px;
  border: 1px solid var(--esign-border-strong);
  background: var(--esign-accent);
  text-align: left;
  font-weight: 700;
  color: #1a1a1a;
}
.hb-table td {
  padding: 8px 10px;
  border: 1px solid var(--esign-border);
  vertical-align: top;
  color: var(--esign-text);
}

.hb-p ::v-deep code, .hb-list ::v-deep code, .hb-steps ::v-deep code, .hb-table ::v-deep code,
.hb-callout ::v-deep code {
  padding: 1px 5px;
  border-radius: 4px;
  background: var(--esign-surface-muted);
  font-size: 12.5px;
}
</style>
